var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatWeOffer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_10990)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_595_10990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3828 0V9.52115H31.6168V0H28.3825H28.3828ZM15.1773 2.86125L12.5277 4.7164L17.9879 12.5137L20.636 10.6585L15.1773 2.86125ZM44.8216 2.86125L39.3631 10.6586L42.0116 12.5138L47.4717 4.7164L44.8221 2.86125H44.8216ZM29.9991 12.1262C22.0878 12.1262 15.6745 16.9303 15.6745 22.8575L23.8131 47.5048H36.1866L44.3245 22.8575C44.3245 16.9305 37.9116 12.1262 29.9999 12.1262H29.9991ZM4.27292 14.9837L3.16797 18.0244L12.1104 21.2801L13.2195 18.2408L4.27272 14.9837H4.27292ZM55.726 14.9837L46.7792 18.2411L47.8845 21.2807L56.8313 18.0244L55.726 14.9837ZM12.7875 28.8841L3.59247 31.3504L4.42677 34.4719L13.6218 32.0092L12.7876 28.8841H12.7875ZM47.2115 28.8841L46.3778 32.0091L55.5728 34.4715L56.4065 31.3499L47.2115 28.884V28.8841ZM23.6327 49.3016V53.5859H36.367V49.3022H23.6327L23.6327 49.3016ZM23.6327 55.7157V60H36.367V55.7164H23.6327L23.6327 55.7157Z",
    fill: "#273B8F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_595_10990",
    x: 3.16797,
    y: 0,
    width: 56.6631,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_595_10990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_595_10990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_10990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeOffer3);
export default __webpack_public_path__ + "static/media/whatWeOffer3.794cd797fb2c2b83870bcedbacffefdb.svg";
export { ForwardRef as ReactComponent };